import { CloseV2, GripDots } from 'src/shared/design-system/Icon';
import { TypeaheadDNDToken } from 'src/shared/design-system/TypeaheadContainer';
import { Clickable } from 'src/shared/design-system/Utilities';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const DeleteIcon = CloseV2;
export const GripIcon = GripDots;

export const Container = styled.div`
  ${Mixins.Flex.set()}
  border: ${Border.Base} ${Colors.GRAY_LITE_20};
  border-radius: ${Border.Radius.M};
`;

export const DraggableContainer = styled(TypeaheadDNDToken)`
  &.rbt-token {
    ${Mixins.Flex.set('flex-start', 'center')}
    background: ${Colors.WHITE};
    border: ${Border.Base} ${Colors.GRAY_LITE_10};
    border-radius: ${Border.Radius.M};
    color: ${Colors.GRAY_DARK_20};
    position: relative;
    padding: 0 ${Spacing.SINGLE_QUARTER} 0 0;
    overflow: hidden;
    margin: 0;
    ${Font.bySize(Font.Size.S)}

    &.rbt-token-active {
      color: ${Colors.GRAY_DARK_20};
    }
  }
  & .rbt-token-remove-button {
    position: absolute;
    border: none;
    height: 100%;
    top: 0 !important;
    bottom: 0;
    cursor: pointer;
    background: transparent;
    width: ${Spacing.DOUBLE_HALF};
    padding: 0;

    &:hover {
      background: rgba(250, 250, 250, 0.9);
    }
    & span {
      font-size: ${Font.Size.L};
    }
  }
`;

export const Label = styled(VerticallyCenteredText)<{ draggable?: boolean }>`
  ${Mixins.Border.setLeftSide(Border.Radius.M)}
  padding: ${ifProp('draggable', `${Spacing.SINGLE} ${Spacing.HALF}`, `${Spacing.EIGHTH} ${Spacing.HALF}`)};
  font-size: ${Font.Size.S};
`;

export const Delete = styled(Clickable)`
  ${Mixins.Flex.center()}
  ${Mixins.Border.setRightSide(Border.Radius.M)}
  background: ${Colors.WHITE};
  color: ${Colors.GRAY};
  transition: background ${Transition.Time.BASE}, color ${Transition.Time.BASE};

  & svg {
    ${Mixins.Shape.square(Spacing.SINGLE)}
  }

  &:hover {
    background: ${Colors.BELL_PEPPER_LITE_30};
    color: ${Colors.BELL_PEPPER_DARK_10};
  }
`;

export const GripContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 ${Spacing.HALF};
`;
